<template>
    <div class="reports-section">
        <skeleton-loader v-if="loading" type="rows" :count="4" />
        <div v-else class="eval-list">
            <div class="eval-item" v-for="(item, i) in history" :key="i" v-ripple @click="showReport(item)">
                <span class="eval-date">{{ item.dateString }}</span>
                <v-icon size="20" color="txtMuted">mdi-magnify</v-icon>
            </div>
            <div v-if="history.length === 0" class="eval-item eval-item--empty">
                {{ $t('common.without_reports') }}
            </div>
        </div>

        <view-report-student ref="reportView" />
        <create-report-student v-if="canCreate" ref="reportCreate" :coach-id="reportCoachId" @saved="loadHistory" />
    </div>
</template>

<script>
import { db } from "@/utils/Firebase";
import SkeletonLoader from "@/components/common/SkeletonLoader";
import ViewReportStudent from '../common/ViewReportStudent.vue';
import CreateReportStudent from '../common/CreateReportStudent.vue';

export default {
    name: "ReportsCard",
    components: { SkeletonLoader, ViewReportStudent, CreateReportStudent },
    props: {
        studentId: {
            type: String,
            default: null,
        },
        student: {
            type: Object,
            default: null,
        },
        coachId: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            loading: false,
            history: [],
        }
    },
    computed: {
        isCoach(vm = this) {
            return vm.accountType === 'coach' || vm.accountType === 'company'
        },
        canCreate(vm = this) {
            return vm.isCoach && !!vm.student
        },
        reportStudent(vm = this) {
            return vm.student || vm.account
        },
        reportCoachId(vm = this) {
            return vm.coachId || vm.student?.studentSubscription?.coachId || vm.currentUser?.uid || null
        },
    },
    async mounted() {
        const vm = this
        await vm.loadHistory()
    },
    methods: {
        async loadHistory() {
            const vm = this
            await vm.withLoading(async () => {
                vm.history = []

                let ref = await db.collection('evaluationReports')
                    .where('studentId', '==', vm.studentId)
                    .orderBy('created_at', 'desc')
                    .limit(3)
                    .get()
                vm.history = ref.docs.map(doc => ({ id: doc.id, ...doc.data(), dateString: vm.$moment(doc.data().date).format('DD/MM/YY') }))
            })
        },
        showReport(item) {
            const vm = this
            vm.$refs.reportView.show({ student: vm.reportStudent, report: item })
        },
        showCreateReport() {
            const vm = this
            if (!vm.student?.assignedEvaluationId) {
                vm.toast(vm.$t('coach.no_assigned_evaluation'))
                return
            }
            vm.$refs.reportCreate.show(vm.student)
        }
    },
}
</script>

<style scoped>
.reports-section {
    display: flex;
    flex-direction: column;
}

.eval-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.eval-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: var(--v-surface2-base);
    border: 1px solid var(--v-outline-base);
    border-radius: 10px;
    padding: 12px 14px;
    cursor: pointer;
    user-select: none;
    transition: background 0.15s;
}

.eval-item:hover {
    background: var(--v-outline-base);
}

.eval-item--empty {
    color: var(--v-txtMuted-base);
    font-size: 13px;
    cursor: default;
}

.eval-item--empty:hover {
    background: var(--v-surface2-base);
}

.eval-date {
    font-size: 14px;
    font-weight: 700;
    color: var(--v-txtPrimary-base);
}
</style>
